// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.switch[data-v-70c02c86] {\n  margin-right: 0;\n  margin-top: 0.25rem;\n}\n.form-group[data-v-70c02c86] {\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: reverse;\n      -ms-flex-direction: row-reverse;\n          flex-direction: row-reverse;\n}\n.form-group[data-v-70c02c86] label.col-form-label {\n  padding-left: 0 !important;\n}\n", ""]);
// Exports
module.exports = exports;
